import type { CustomOption, CustomOptionValue } from "core/catalog";
import { useEffect, useState } from "react";
import {
  RadioGroup,
  RadioInput,
} from "~/design-system/components/form/RadioInput";
import { CustomOptionLabel } from "./CustomOptionLabel";
import { OptionValueRow } from "./OptionValueRow";

type RadioInputOptionProps = {
  customOption: CustomOption;
  onChange?: (value: string | string[] | number) => void;
};

export function RadioInputOption({
  customOption,
  onChange,
}: RadioInputOptionProps) {
  const values = customOption.values || [];
  const [selectedValue, setSelectedValue] = useState<
    string | string[] | number | undefined
  >(undefined);

  useEffect(() => {
    if (!customOption.defaultValue) return;
    const defaultValue = Array.isArray(customOption.defaultValue)
      ? customOption.defaultValue.map(String)
      : String(customOption.defaultValue);

    setSelectedValue(defaultValue);
  }, [customOption.defaultValue]);

  const handleSelectValue = (value: string | string[] | number) => {
    setSelectedValue(value);
    onChange?.(value);
  };

  if (values.length === 0) {
    return null;
  }

  return (
    <RadioGroup
      name={customOption.id}
      label={<CustomOptionLabel customOption={customOption} />}
      defaultValue={selectedValue}
      onChange={handleSelectValue}
      classes={{
        wrapper: "w-full",
        input: "gap-2 sm:flex-wrap",
      }}
    >
      {values.map((value: CustomOptionValue) => (
        <RadioInput
          key={value.id}
          defaultValue={value.id}
          classes={{
            wrapper: "px-2 gap-2 w-fit",
            label: "py-2 px-0 w-fit",
          }}
        >
          <OptionValueRow value={value} />
        </RadioInput>
      ))}
    </RadioGroup>
  );
}
